import { m } from "@/paraglide/messages.js";

export type AudienceMode = "beginner" | "amateur" | "tournament";

export type MethodStepSection = {
  heading: string;
  paragraphs: string[];
};

export type EglyMethodStep = {
  n: string;
  title: string;
  summary: string;
  beginner: string;
  amateur: string;
  tournament: string;
  detail: {
    beginner: MethodStepSection[];
    amateur: MethodStepSection[];
    tournament: MethodStepSection[];
  };
};

export function getEglyMethodSteps(): EglyMethodStep[] {
  return [
    {
      n: "01",
      title: m.method_content_step_01_title(),
      summary: m.method_content_step_01_summary(),
      beginner: m.method_content_step_01_beginner(),
      amateur: m.method_content_step_01_amateur(),
      tournament: m.method_content_step_01_tournament(),
      detail: {
        beginner: [
          {
            heading: m.method_content_step_01_detail_beginner_0_heading(),
            paragraphs: [
              m.method_content_step_01_detail_beginner_0_paragraphs_0(),
              m.method_content_step_01_detail_beginner_0_paragraphs_1(),
              m.method_content_step_01_detail_beginner_0_paragraphs_2(),
            ],
          },
          {
            heading: m.method_content_step_01_detail_beginner_1_heading(),
            paragraphs: [
              m.method_content_step_01_detail_beginner_1_paragraphs_0(),
              m.method_content_step_01_detail_beginner_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_01_detail_beginner_2_heading(),
            paragraphs: [
              m.method_content_step_01_detail_beginner_2_paragraphs_0(),
              m.method_content_step_01_detail_beginner_2_paragraphs_1(),
            ],
          },
        ],
        amateur: [
          {
            heading: m.method_content_step_01_detail_amateur_0_heading(),
            paragraphs: [
              m.method_content_step_01_detail_amateur_0_paragraphs_0(),
              m.method_content_step_01_detail_amateur_0_paragraphs_1(),
              m.method_content_step_01_detail_amateur_0_paragraphs_2(),
            ],
          },
          {
            heading: m.method_content_step_01_detail_amateur_1_heading(),
            paragraphs: [
              m.method_content_step_01_detail_amateur_1_paragraphs_0(),
              m.method_content_step_01_detail_amateur_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_01_detail_amateur_2_heading(),
            paragraphs: [
              m.method_content_step_01_detail_amateur_2_paragraphs_0(),
              m.method_content_step_01_detail_amateur_2_paragraphs_1(),
            ],
          },
        ],
        tournament: [
          {
            heading: m.method_content_step_01_detail_tournament_0_heading(),
            paragraphs: [
              m.method_content_step_01_detail_tournament_0_paragraphs_0(),
              m.method_content_step_01_detail_tournament_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_01_detail_tournament_1_heading(),
            paragraphs: [
              m.method_content_step_01_detail_tournament_1_paragraphs_0(),
              m.method_content_step_01_detail_tournament_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_01_detail_tournament_2_heading(),
            paragraphs: [
              m.method_content_step_01_detail_tournament_2_paragraphs_0(),
              m.method_content_step_01_detail_tournament_2_paragraphs_1(),
            ],
          },
        ],
      },
    },
    {
      n: "02",
      title: m.method_content_step_02_title(),
      summary: m.method_content_step_02_summary(),
      beginner: m.method_content_step_02_beginner(),
      amateur: m.method_content_step_02_amateur(),
      tournament: m.method_content_step_02_tournament(),
      detail: {
        beginner: [
          {
            heading: m.method_content_step_02_detail_beginner_0_heading(),
            paragraphs: [
              m.method_content_step_02_detail_beginner_0_paragraphs_0(),
              m.method_content_step_02_detail_beginner_0_paragraphs_1(),
              m.method_content_step_02_detail_beginner_0_paragraphs_2(),
            ],
          },
          {
            heading: m.method_content_step_02_detail_beginner_1_heading(),
            paragraphs: [
              m.method_content_step_02_detail_beginner_1_paragraphs_0(),
              m.method_content_step_02_detail_beginner_1_paragraphs_1(),
              m.method_content_step_02_detail_beginner_1_paragraphs_2(),
            ],
          },
          {
            heading: m.method_content_step_02_detail_beginner_2_heading(),
            paragraphs: [
              m.method_content_step_02_detail_beginner_2_paragraphs_0(),
              m.method_content_step_02_detail_beginner_2_paragraphs_1(),
            ],
          },
        ],
        amateur: [
          {
            heading: m.method_content_step_02_detail_amateur_0_heading(),
            paragraphs: [
              m.method_content_step_02_detail_amateur_0_paragraphs_0(),
              m.method_content_step_02_detail_amateur_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_02_detail_amateur_1_heading(),
            paragraphs: [
              m.method_content_step_02_detail_amateur_1_paragraphs_0(),
              m.method_content_step_02_detail_amateur_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_02_detail_amateur_2_heading(),
            paragraphs: [
              m.method_content_step_02_detail_amateur_2_paragraphs_0(),
              m.method_content_step_02_detail_amateur_2_paragraphs_1(),
            ],
          },
        ],
        tournament: [
          {
            heading: m.method_content_step_02_detail_tournament_0_heading(),
            paragraphs: [
              m.method_content_step_02_detail_tournament_0_paragraphs_0(),
              m.method_content_step_02_detail_tournament_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_02_detail_tournament_1_heading(),
            paragraphs: [
              m.method_content_step_02_detail_tournament_1_paragraphs_0(),
              m.method_content_step_02_detail_tournament_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_02_detail_tournament_2_heading(),
            paragraphs: [
              m.method_content_step_02_detail_tournament_2_paragraphs_0(),
              m.method_content_step_02_detail_tournament_2_paragraphs_1(),
            ],
          },
        ],
      },
    },
    {
      n: "03",
      title: m.method_content_step_03_title(),
      summary: m.method_content_step_03_summary(),
      beginner: m.method_content_step_03_beginner(),
      amateur: m.method_content_step_03_amateur(),
      tournament: m.method_content_step_03_tournament(),
      detail: {
        beginner: [
          {
            heading: m.method_content_step_03_detail_beginner_0_heading(),
            paragraphs: [
              m.method_content_step_03_detail_beginner_0_paragraphs_0(),
              m.method_content_step_03_detail_beginner_0_paragraphs_1(),
              m.method_content_step_03_detail_beginner_0_paragraphs_2(),
              m.method_content_step_03_detail_beginner_0_paragraphs_3(),
            ],
          },
          {
            heading: m.method_content_step_03_detail_beginner_1_heading(),
            paragraphs: [
              m.method_content_step_03_detail_beginner_1_paragraphs_0(),
              m.method_content_step_03_detail_beginner_1_paragraphs_1(),
              m.method_content_step_03_detail_beginner_1_paragraphs_2(),
              m.method_content_step_03_detail_beginner_1_paragraphs_3(),
              m.method_content_step_03_detail_beginner_1_paragraphs_4(),
              m.method_content_step_03_detail_beginner_1_paragraphs_5(),
            ],
          },
        ],
        amateur: [
          {
            heading: m.method_content_step_03_detail_amateur_0_heading(),
            paragraphs: [
              m.method_content_step_03_detail_amateur_0_paragraphs_0(),
              m.method_content_step_03_detail_amateur_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_03_detail_amateur_1_heading(),
            paragraphs: [
              m.method_content_step_03_detail_amateur_1_paragraphs_0(),
              m.method_content_step_03_detail_amateur_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_03_detail_amateur_2_heading(),
            paragraphs: [
              m.method_content_step_03_detail_amateur_2_paragraphs_0(),
              m.method_content_step_03_detail_amateur_2_paragraphs_1(),
              m.method_content_step_03_detail_amateur_2_paragraphs_2(),
            ],
          },
        ],
        tournament: [
          {
            heading: m.method_content_step_03_detail_tournament_0_heading(),
            paragraphs: [
              m.method_content_step_03_detail_tournament_0_paragraphs_0(),
              m.method_content_step_03_detail_tournament_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_03_detail_tournament_1_heading(),
            paragraphs: [
              m.method_content_step_03_detail_tournament_1_paragraphs_0(),
              m.method_content_step_03_detail_tournament_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_03_detail_tournament_2_heading(),
            paragraphs: [
              m.method_content_step_03_detail_tournament_2_paragraphs_0(),
              m.method_content_step_03_detail_tournament_2_paragraphs_1(),
            ],
          },
        ],
      },
    },
    {
      n: "04",
      title: m.method_content_step_04_title(),
      summary: m.method_content_step_04_summary(),
      beginner: m.method_content_step_04_beginner(),
      amateur: m.method_content_step_04_amateur(),
      tournament: m.method_content_step_04_tournament(),
      detail: {
        beginner: [
          {
            heading: m.method_content_step_04_detail_beginner_0_heading(),
            paragraphs: [
              m.method_content_step_04_detail_beginner_0_paragraphs_0(),
              m.method_content_step_04_detail_beginner_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_04_detail_beginner_1_heading(),
            paragraphs: [
              m.method_content_step_04_detail_beginner_1_paragraphs_0(),
              m.method_content_step_04_detail_beginner_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_04_detail_beginner_2_heading(),
            paragraphs: [
              m.method_content_step_04_detail_beginner_2_paragraphs_0(),
              m.method_content_step_04_detail_beginner_2_paragraphs_1(),
            ],
          },
        ],
        amateur: [
          {
            heading: m.method_content_step_04_detail_amateur_0_heading(),
            paragraphs: [
              m.method_content_step_04_detail_amateur_0_paragraphs_0(),
              m.method_content_step_04_detail_amateur_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_04_detail_amateur_1_heading(),
            paragraphs: [
              m.method_content_step_04_detail_amateur_1_paragraphs_0(),
              m.method_content_step_04_detail_amateur_1_paragraphs_1(),
              m.method_content_step_04_detail_amateur_1_paragraphs_2(),
            ],
          },
        ],
        tournament: [
          {
            heading: m.method_content_step_04_detail_tournament_0_heading(),
            paragraphs: [
              m.method_content_step_04_detail_tournament_0_paragraphs_0(),
              m.method_content_step_04_detail_tournament_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_04_detail_tournament_1_heading(),
            paragraphs: [
              m.method_content_step_04_detail_tournament_1_paragraphs_0(),
              m.method_content_step_04_detail_tournament_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_04_detail_tournament_2_heading(),
            paragraphs: [
              m.method_content_step_04_detail_tournament_2_paragraphs_0(),
              m.method_content_step_04_detail_tournament_2_paragraphs_1(),
            ],
          },
        ],
      },
    },
    {
      n: "05",
      title: m.method_content_step_05_title(),
      summary: m.method_content_step_05_summary(),
      beginner: m.method_content_step_05_beginner(),
      amateur: m.method_content_step_05_amateur(),
      tournament: m.method_content_step_05_tournament(),
      detail: {
        beginner: [
          {
            heading: m.method_content_step_05_detail_beginner_0_heading(),
            paragraphs: [
              m.method_content_step_05_detail_beginner_0_paragraphs_0(),
              m.method_content_step_05_detail_beginner_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_05_detail_beginner_1_heading(),
            paragraphs: [
              m.method_content_step_05_detail_beginner_1_paragraphs_0(),
              m.method_content_step_05_detail_beginner_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_05_detail_beginner_2_heading(),
            paragraphs: [
              m.method_content_step_05_detail_beginner_2_paragraphs_0(),
              m.method_content_step_05_detail_beginner_2_paragraphs_1(),
            ],
          },
        ],
        amateur: [
          {
            heading: m.method_content_step_05_detail_amateur_0_heading(),
            paragraphs: [
              m.method_content_step_05_detail_amateur_0_paragraphs_0(),
              m.method_content_step_05_detail_amateur_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_05_detail_amateur_1_heading(),
            paragraphs: [
              m.method_content_step_05_detail_amateur_1_paragraphs_0(),
              m.method_content_step_05_detail_amateur_1_paragraphs_1(),
              m.method_content_step_05_detail_amateur_1_paragraphs_2(),
            ],
          },
        ],
        tournament: [
          {
            heading: m.method_content_step_05_detail_tournament_0_heading(),
            paragraphs: [
              m.method_content_step_05_detail_tournament_0_paragraphs_0(),
              m.method_content_step_05_detail_tournament_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_05_detail_tournament_1_heading(),
            paragraphs: [
              m.method_content_step_05_detail_tournament_1_paragraphs_0(),
              m.method_content_step_05_detail_tournament_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_05_detail_tournament_2_heading(),
            paragraphs: [
              m.method_content_step_05_detail_tournament_2_paragraphs_0(),
              m.method_content_step_05_detail_tournament_2_paragraphs_1(),
            ],
          },
        ],
      },
    },
    {
      n: "06",
      title: m.method_content_step_06_title(),
      summary: m.method_content_step_06_summary(),
      beginner: m.method_content_step_06_beginner(),
      amateur: m.method_content_step_06_amateur(),
      tournament: m.method_content_step_06_tournament(),
      detail: {
        beginner: [
          {
            heading: m.method_content_step_06_detail_beginner_0_heading(),
            paragraphs: [
              m.method_content_step_06_detail_beginner_0_paragraphs_0(),
              m.method_content_step_06_detail_beginner_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_06_detail_beginner_1_heading(),
            paragraphs: [
              m.method_content_step_06_detail_beginner_1_paragraphs_0(),
              m.method_content_step_06_detail_beginner_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_06_detail_beginner_2_heading(),
            paragraphs: [
              m.method_content_step_06_detail_beginner_2_paragraphs_0(),
              m.method_content_step_06_detail_beginner_2_paragraphs_1(),
            ],
          },
        ],
        amateur: [
          {
            heading: m.method_content_step_06_detail_amateur_0_heading(),
            paragraphs: [
              m.method_content_step_06_detail_amateur_0_paragraphs_0(),
              m.method_content_step_06_detail_amateur_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_06_detail_amateur_1_heading(),
            paragraphs: [
              m.method_content_step_06_detail_amateur_1_paragraphs_0(),
              m.method_content_step_06_detail_amateur_1_paragraphs_1(),
              m.method_content_step_06_detail_amateur_1_paragraphs_2(),
            ],
          },
          {
            heading: m.method_content_step_06_detail_amateur_2_heading(),
            paragraphs: [
              m.method_content_step_06_detail_amateur_2_paragraphs_0(),
              m.method_content_step_06_detail_amateur_2_paragraphs_1(),
              m.method_content_step_06_detail_amateur_2_paragraphs_2(),
            ],
          },
          {
            heading: m.method_content_step_06_detail_amateur_3_heading(),
            paragraphs: [
              m.method_content_step_06_detail_amateur_3_paragraphs_0(),
              m.method_content_step_06_detail_amateur_3_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_06_detail_amateur_4_heading(),
            paragraphs: [m.method_content_step_06_detail_amateur_4_paragraphs_0()],
          },
          {
            heading: m.method_content_step_06_detail_amateur_5_heading(),
            paragraphs: [
              m.method_content_step_06_detail_amateur_5_paragraphs_0(),
              m.method_content_step_06_detail_amateur_5_paragraphs_1(),
            ],
          },
        ],
        tournament: [
          {
            heading: m.method_content_step_06_detail_tournament_0_heading(),
            paragraphs: [
              m.method_content_step_06_detail_tournament_0_paragraphs_0(),
              m.method_content_step_06_detail_tournament_0_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_06_detail_tournament_1_heading(),
            paragraphs: [
              m.method_content_step_06_detail_tournament_1_paragraphs_0(),
              m.method_content_step_06_detail_tournament_1_paragraphs_1(),
            ],
          },
          {
            heading: m.method_content_step_06_detail_tournament_2_heading(),
            paragraphs: [
              m.method_content_step_06_detail_tournament_2_paragraphs_0(),
              m.method_content_step_06_detail_tournament_2_paragraphs_1(),
            ],
          },
        ],
      },
    },
  ];
}

export function getEglyMethodIntro(): Record<AudienceMode, string> {
  return {
    beginner: m.method_content_intro_beginner(),
    amateur: m.method_content_intro_amateur(),
    tournament: m.method_content_intro_tournament(),
  };
}

export function getAudienceModeLabel(): Record<AudienceMode, string> {
  return {
    beginner: m.method_audience_beginner(),
    amateur: m.method_audience_amateur(),
    tournament: m.method_audience_tournament(),
  };
}

export function stepExplanation(step: EglyMethodStep, audience: AudienceMode): string {
  return step[audience];
}

export function stepDetailSections(
  step: EglyMethodStep,
  audience: AudienceMode,
): MethodStepSection[] {
  return step.detail[audience];
}
